module.exports = __webpack_public_path__ + "img/campus-2.144fd29f.png";